const createRow = require('../createRow')
const TablePosition = require('../TablePosition')

/**
 * Insert a new row in current table
 *
 * @param {Object} opts
 * @param {Slate.Transform} transform
 * @param {Number} at
 * @param {Function} textGetter
 * @return {Slate.Transform}
 */
function insertRow (opts, transform, at, textGetter) {
  const { state } = transform
  const { startBlock } = state

  window.TablePosition = TablePosition
  window.opts = opts
  const pos = TablePosition.create(state, startBlock, opts)
  const { table } = pos

    // Create a new row with the right count of cells
  const firstRow = table.nodes.get(0)
  const newRow = createRow(opts, firstRow.nodes.size, textGetter)
  const currentRow = table.nodes.get(pos.getRowIndex())

  if (typeof at === 'undefined') {
    at = pos.getRowIndex() + 1
  }

  return transform
        // to trigger tooltip to disappear
        .setNodeByKey(currentRow.key, {data: {isFocused: false}})

        .insertNodeByKey(table.key, at, newRow)

        .collapseToEndOf(
            newRow.nodes.get(0)
        )
        .focus()
}

module.exports = insertRow



// WEBPACK FOOTER //
// ./src/components/DeepTableSlatePlugin/deep-table-plugin/transforms/insertRow.js